// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1B7D6","buttonPrimary":"Button_buttonPrimary__2VL-c","buttonSecondary":"Button_buttonSecondary__3NoAH"};